import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import Auth3 from "../../../api/Auth3";

const initialState = {
  isLoading: false,
  error: null,
  accessToken: localStorage.getItem("access_token") || null,
  success: null,
  user: null,
};

export const ContactUs = createAsyncThunk(
  "contact/ContactUs",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await Auth3.post("/contact/contact-us", formData);
      return response.data;
    } catch (err) {
      const errorMessage =
        err.response?.data?.detail || "Please try again.";
      return rejectWithValue(errorMessage);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(ContactUs.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(ContactUs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message || "Login successful";
        toast.success(state.success);
      })
      .addCase(ContactUs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        toast.error(state.error);
      })
  },
});

export default authSlice.reducer;